import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AnalyticsDistribution, AnalyticsFilters, AnalyticsGeo, AnalyticsPerformance, AnalyticsSnapshot, AnalyticsTrends } from '../models/permit-analytics.model';

@Injectable()
export class PermitAnalyticsService {
    private readonly baseUrl = `${environment.API_GATEWAY_URL}/permit/admin/analytics`;

    constructor(private http: HttpClient) {}

    getSnapshot(filters?: AnalyticsFilters): Observable<AnalyticsSnapshot> {
        return this.http.get<AnalyticsSnapshot>(`${this.baseUrl}/snapshot`, { params: this.buildParams(filters) });
    }

    getDistribution(filters?: AnalyticsFilters & { groupBy?: string }): Observable<AnalyticsDistribution> {
        return this.http.get<AnalyticsDistribution>(`${this.baseUrl}/distribution`, { params: this.buildParams(filters) });
    }

    getTrends(filters?: AnalyticsFilters & { category?: string; granularity?: string }): Observable<AnalyticsTrends> {
        return this.http.get<AnalyticsTrends>(`${this.baseUrl}/trends`, { params: this.buildParams(filters) });
    }

    getPerformance(filters?: AnalyticsFilters): Observable<AnalyticsPerformance> {
        return this.http.get<AnalyticsPerformance>(`${this.baseUrl}/performance`, { params: this.buildParams(filters) });
    }

    getGeo(filters?: AnalyticsFilters & { category?: string }): Observable<AnalyticsGeo> {
        return this.http.get<AnalyticsGeo>(`${this.baseUrl}/geo`, { params: this.buildParams(filters) });
    }

    private buildParams(filters?: Record<string, any>): HttpParams {
        let params = new HttpParams();
        if (!filters) return params;
        for (const [key, value] of Object.entries(filters)) {
            if (value != null) params = params.set(key, value);
        }
        return params;
    }
}
